"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DividedContainer = _interopRequireDefault(require("./DividedContainer.style"));
var _Paragraph = _interopRequireDefault(require("./Paragraph"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DividedContainer = function DividedContainer(_ref) {
  var title = _ref.title,
    isTimeVisible = _ref.isTimeVisible,
    headerLabel = _ref.headerLabel,
    leftChildren = _ref.leftChildren,
    rightChildren = _ref.rightChildren,
    withBorder = _ref.withBorder,
    leftWidth = _ref.leftWidth,
    rightWidth = _ref.rightWidth,
    mobileOnTop = _ref.mobileOnTop,
    separatorColor = _ref.separatorColor,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_DividedContainer["default"], {
    className: "divided-container ".concat(className),
    "data-testid": className,
    withBorder: withBorder,
    leftWidth: leftWidth,
    rightWidth: rightWidth,
    mobileOnTop: mobileOnTop,
    separatorColor: separatorColor
  }, title && /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    className: "container-title"
  }, title), isTimeVisible && headerLabel, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-left ".concat(mobileOnTop === 'left' ? 'with-separator' : '')
  }, leftChildren), /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-right ".concat(mobileOnTop === 'right' ? 'with-separator' : '')
  }, rightChildren));
};
DividedContainer.propTypes = {
  title: _propTypes["default"].string,
  headerLabel: _propTypes["default"].node,
  isTimeVisible: _propTypes["default"].bool,
  leftChildren: _propTypes["default"].node.isRequired,
  rightChildren: _propTypes["default"].node.isRequired,
  leftWidth: _propTypes["default"].string,
  rightWidth: _propTypes["default"].string,
  withBorder: _propTypes["default"].bool,
  mobileOnTop: _propTypes["default"].oneOf(['left', 'right']),
  separatorColor: _propTypes["default"].string,
  className: _propTypes["default"].string
};
DividedContainer.defaultProps = {
  title: '',
  headerLabel: '',
  isTimeVisible: false,
  withBorder: false,
  leftWidth: '',
  rightWidth: '',
  mobileOnTop: 'left',
  separatorColor: '',
  className: ''
};
var _default = exports["default"] = DividedContainer;